import React, { forwardRef } from "react";
import { LoadingSpinner } from "./LoadingSpinner";

interface LoadingPageProps extends React.HTMLProps<HTMLDivElement> {
  loadingText?: string;
}

const LoadingPage = forwardRef<HTMLDivElement, LoadingPageProps>((props, ref) => {
  return (
    <div
      ref={ref}
      {...props}
      className={`flex h-full w-full flex-col items-center justify-center gap-4${props.className ? ` ${props.className}` : ""}`}
    >
      <LoadingSpinner size={100} className="text-primary" />
      <p className="text-2xl font-medium text-white">{props.loadingText}</p>
    </div>
  );
});

export default LoadingPage;